import React, { useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BannerSlider from './components/Home/Bannerslider';
import SignupTo from "./components/Home/SignupTo";
import AOS from 'aos';
import 'aos/dist/aos.css';
import MiShopDiamondsByShap from "./components/Home/MiShopDiamondsByShap";
import MiDiamondEngRing from "./components/Home/MiDiamondEngRing";
import MiBestSeller from "./components/Home/MiBestSeller";
import MiWeddingRingFineJewelry from "./components/Home/MiWeddingRingFineJewelry";
import MiCustomDesign from "./components/Home/MiCustomDesign";
import MiClintSlider from "./components/Home/MiClintSlider";
import MiCustomer from "./components/Home/MiCustomer";
import MiCollectionAccordian from "./components/Home/MiCollectionAccordian";
// import { Theme } from "../../../../Helpers/request";

// if(Theme === 'miami'){
// require(`./assets/css/miami.css`);
// }
const MiamiHome = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      // disable: 'mobile'
    });
  }, []);

  return (
    <div className="mi_custom_body_container MiamiThemHome">
      <BannerSlider />
      <MiShopDiamondsByShap />
      <MiDiamondEngRing />
      <MiBestSeller />
      <MiWeddingRingFineJewelry />
      <MiCustomDesign />
      <MiClintSlider/>
      <MiCustomer />
      <SignupTo />
      <MiCollectionAccordian/>
    </div>
  )
}

export default MiamiHome;